import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { FilterDropdownPropertyItem, FilterPropertyDropdownComponent } from 'src/app/shared/components/filter-property-dropdown/filter-property-dropdown.component';
import { TabPillGroupButton, TabPillGroupButtonComponent } from 'src/app/shared/components/tab-pill-group-button/tab-pill-group-button.component';

@Component({
  selector: 'app-step-one',
  standalone: true,
  imports: [CommonModule, TranslocoDirective, FilterPropertyDropdownComponent, TabPillGroupButtonComponent],
  templateUrl: './step-one.component.html',
  styleUrl: './step-one.component.css'
})
export class StepOneComponent implements OnInit{
  public caseItem: string | null = null;
  public dropdownPropertyItems: FilterDropdownPropertyItem[] = [
    {
      key: '1',
      title: 'Suggested 1',
      address: 'SuggestedSuggestedSuggested',
      extraInfo: '2021 - 1ος Όροφος - 4 Yπνοδωμάτια - 2 Mπάνια',
    },
    {
      key: '2',
      title: 'Suggested 2',
      address: 'SuggestedSuggestedSuggested',
      extraInfo: '2021 - 1ος Όροφος - 4 Yπνοδωμάτια - 2 Mπάνια',
    },
    {
      key: '3',
      title: 'Suggested 3',
      address: 'SuggestedSuggestedSuggested',
      extraInfo: '2021 - 1ος Όροφος - 4 Yπνοδωμάτια - 2 Mπάνια',
    }
  ];
  public tabPillGroupButtons: TabPillGroupButton[] = [
    {
      key: 'my-listings',
      title: 'Οι καταχωρίσεις μου',
      icon: 'icon-house',
    },
    {
      key: 'favorites',
      title: 'Αγαπημένα',
      icon: 'icon-heart-line',
    },
    {
      key: 'enter-code',
      title: 'Βάλε κωδικό',
      icon: 'icon-edit',
    },
  ];

  ngOnInit(): void {

  }
  
  handleButtonGroupItemSelected(item: any) {
    console.log('Selected Item:', item);
    this.caseItem = item;
  }
}
